<!--
 * @Author: your name
 * @Date: 2022-01-04 16:10:39
 * @LastEditTime: 2022-02-21 15:06:45
 * @LastEditors: your name
 * @Description: 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
 * @FilePath: \unifiedCrm-front-end\src\App.vue
-->
<template>
  <div class="height-100" id="app">
    <router-view></router-view>
  </div>
</template>

<script>
import { getCookieValue, clearCookie, setCookie } from '@/utils';
export default {
  name: 'App',
  created() {
    // 当从美居项目dcp跳转过来，没有权限的时候，弹框提示 成功是：PermissionAllow 不提示
    if (getCookieValue('jumpToCmms') && !getCookieValue('isAlertJumpToCmms')) {
      let jumpToCmms = getCookieValue('jumpToCmms');
      if (jumpToCmms === 'NoPermission') {
        // alert('您没有cmms系统权限哦，请先申请权限');
        this.$confirm('您还没有开通营销云的对应的功能权限，请先申请开通权限', '温馨提示', {
          confirmButtonText: '申请权限',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {
          window.open('http://iflow.midea.com/iflow.html?fdrouter=/processForm/edit/fdId/1040048513960005632#/', '_blank');
        });
      } else if (jumpToCmms === 'NoOperationManageMenu') {
        // this.$alert('您还没有开通营销云的对应的功能权限，请先申请开通权限', '温馨提示', {
        //   confirmButtonText: '确定'
        // });
        this.$confirm('您还没有开通营销云的对应的功能权限，请先申请开通权限', '温馨提示', {
          confirmButtonText: '申请权限',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {
          window.open('http://iflow.midea.com/iflow.html?fdrouter=/processForm/edit/fdId/1040048513960005632#/', '_blank');
        });
      }
      setCookie('isAlertJumpToCmms', true);
      clearCookie('jumpToCmms', '.midea.com');
    }
  },
};
</script>

<style>
html, .height-100{
  height: 100%;
}
.el-tooltip__popper{
  max-width: 800px;
}
</style>
